import { isNotNil } from '@flowio/is';
import isInternalPaymentRequest from './isInternalPaymentRequest';

export function assertPaymentRequest(
  pr: io.flow.v0.models.PaymentRequest
  | io.flow.internal.v0.models.InternalPaymentRequest
  | undefined,
): io.flow.v0.models.PaymentRequest | undefined {
  if (isNotNil(pr) && isInternalPaymentRequest(pr)) {
    throw new Error('Unexpected PR model: io.flow.internal.v0.models.InternalPaymentRequest');
  }
  return pr;
}

export function assertInternalPaymentRequest(
  pr: io.flow.v0.models.PaymentRequest
  | io.flow.internal.v0.models.InternalPaymentRequest
  | undefined,
): io.flow.internal.v0.models.InternalPaymentRequest | undefined {
  if (isNotNil(pr) && !isInternalPaymentRequest(pr)) {
    throw new Error('Unexpected PR model: io.flow.internal.v0.models.PaymentRequest');
  }
  return pr;
}
